var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.mx_moduleFlavour,{tag:"component",staticClass:"DutiesView",attrs:{"moduleConfig":_vm.mx_moduleConfig}})}
var staticRenderFns = []

export { render, staticRenderFns }